<app-product-image-display *ngIf="showProductImage"
  (click)="changeShowProductImage()"
  [url]="currentProductImageUrl">
</app-product-image-display>
<div class="second-reader-container">
  <h3>Detalhes dos produtos</h3>
  <app-display-mode-control (displayModeChange)="onDisplayModeChange($event)" [initialValue]="displayMode"></app-display-mode-control>
</div>
<div class="lower-content">
  <div *ngIf="displayMode === 'list'" class="carousel-wrapper">
    <button class="carousel-arrow" (click)="carouselPrev()" [disabled]="!canScrollLeft">&#8249;</button>
    <div class="list-container">
      <app-product-details *ngFor="let product of visibleProducts" [product]="product" (click)="onProductClick($event)"></app-product-details>
    </div>
    <button class="carousel-arrow" (click)="carouselNext()" [disabled]="!canScrollRight">&#8250;</button>
  </div>
  <div *ngIf="displayMode === 'table'" class="table-container">
    <table mat-table [dataSource]="products" class="table">
      <ng-container matColumnDef="name">
        <th mat-header-cell class="header" *matHeaderCellDef>Descrição</th>
        <td mat-cell *matCellDef="let element">{{element.name || element?.productName || '---'}}</td>
      </ng-container>

      <ng-container matColumnDef="packSize">
        <th mat-header-cell class="header" *matHeaderCellDef>Tamanho do Pacote</th>
        <td mat-cell *matCellDef="let element">
          {{ element.packSize ? (element.packSize | number:'1.0-0':'pt-BR')  : '---' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell class="header" *matHeaderCellDef>Quantidade</th>
        <td mat-cell *matCellDef="let element">{{element.quantity | number:'1.0-0':'pt-BR'}}</td>
      </ng-container>

      <ng-container matColumnDef="sku">
        <th mat-header-cell class="header" *matHeaderCellDef>Código do Item</th>
        <td mat-cell *matCellDef="let element">{{element.sku}}</td>
      </ng-container>

      <tr mat-header-row class="header-container" *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row class="item-container" *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <div *ngIf="!products.length" class="no-item">
    Não existem produtos neste pallet
  </div>
</div>
